import colors from 'vuetify/lib/util/colors'
export default {
  primary: colors.purple,
  secondary: colors.grey.darken1,
  accent: colors.shades.black,
  error: colors.red.accent3
}

// export default {
//   primary: '#4caf50',
//   secondary: '#4caf50',
//   tertiary: '#495057',
//   accent: '#82B1FF',
//   error: '#f55a4e',
//   info: '#00d3ee',
//   success: '#5cb860',
//   warning: '#ffa21a'
// }
